module.exports = __webpack_public_path__ + "img/MapThumb_MountainCrossing.69f9a2c6.webp";